class navbarHelper {
    constructor() {
        const toggles = Array.from(document.querySelectorAll('[data-toggle="navbar-search"]')),
            searchEl = document.getElementById('navbar-search'),
            searchInput = document.getElementById('navbar-search-input');
        toggles.forEach((toggle, i) => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                if (searchEl.classList.contains('show')) {
                    searchEl.classList.remove('show');
                } else {
                    searchEl.classList.add('show');
                    setTimeout(() => {
                        searchInput.focus();
                    }, 200);
                }
            });
        });

        this.bindCloseEvent();
        this.bindSearchModal();
        this.bindHideOnPathFactory();
    }
    
    bindSearchModal() {
        var modal = $('#search-modal'), input = $('#search-modal-input');
        modal.on('shown.bs.modal', function () {
            input.focus();
        });
    }

    bindCloseEvent() {
        $('.navbar-dropdown').on('click', function(e) {
            e.stopPropagation();
        });
        
        $(document).on('click', function (e) {
            $('.navbar-dropdown').collapse('hide');
        });
    }

    bindHideOnPathFactory() {
        if(this.inIframe() && document.referrer.startsWith('https://resources.accusoft.com')) {
            document.querySelectorAll('.page-footer, #main-nav, .back-to-link').forEach((item) => {
                item.style.display = 'none';
            });
        }
    }

    inIframe () {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }
}
window.app.add('navbar', new navbarHelper());